import { ListItemText, MenuItem, TextField } from "@mui/material";
import { FC } from "react";
import { CommissionTypes } from "../../api/dtos";

interface ISalesTypeFilterSelect {
    selectedCommissionType: CommissionTypes | undefined,
    setSelectedCommissionType: React.Dispatch<React.SetStateAction<CommissionTypes | undefined>>,
}

const SalesTypeFilterSelect: FC<ISalesTypeFilterSelect> = ({
    selectedCommissionType,
    setSelectedCommissionType
}) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newValue = !Number.isNaN(Number(event.target.value)) ? Number(event.target.value) : undefined;
        setSelectedCommissionType(newValue)
    }
    return (
        <>
            <TextField
                select
                onChange={handleChange}
                value={selectedCommissionType ?? ""}
                label={"Sales Type"}
                sx={{
                    width: 200
                }}
            >
                <MenuItem key={CommissionTypes.Exchange} value={CommissionTypes.Exchange}><ListItemText primary={"Exchange"} /></MenuItem>
                <MenuItem key={CommissionTypes.Settlement} value={CommissionTypes.Settlement}><ListItemText primary={"Settlement"} /></MenuItem>
            </TextField>
        </>
    );
}

export default SalesTypeFilterSelect;